import type { AxiosRequestConfig } from 'axios'

export type RetryableRequestConfig = AxiosRequestConfig & {
  _isRetry?: boolean
}

export const canRetryUnauthorized = (config?: RetryableRequestConfig): config is RetryableRequestConfig =>
  Boolean(config && !config._isRetry)

export const markUnauthorizedRetry = (config: RetryableRequestConfig): void => {
  config._isRetry = true
}
